<div *ngIf="hasTabs$ | async" class="toolbar" (window:resize)="checkScrollBar()">
  <section class="tabs-container" *ngIf="!deviceService.isHandset()">
    <div class="change-btn prev" (click)="scrollTab(-1)" *ngIf="overflow" [ngClass]="{'hide' : scrollStart}">
      <mat-icon>keyboard_arrow_left</mat-icon>
    </div>
    <div class="tabs" #scroller (dragover)="isDropZone($event)" (wheel)="scrollTab($event.deltaY)" id="scroller">
      <ng-container *ngFor="let tab of persistentTabService.getTabs$() | async">
        <div #tab [id]="tab.config.idURL" class="tab" [class.active]="tab.config.idURL === activeTabId"
             (click)="navigateTab(tab)" draggable="true"
             (dragstart)="dragTabStart($event, tab)"
             (drop)="dropTab($event, tab)">
          <mat-icon class="tab-icon">{{ tab.config.icon }}</mat-icon>
          <div class="more-info-container">
            <div textSmall class="tab-text">{{ tab.config.label }}</div>
            <div textSmall class="tab-text additional">{{ tab.config.sublabel }}</div>
          </div>
          @if (tab.config.loading) {
            <app-loader [dotted]="true"></app-loader>
          }
          <mat-icon class="close-icon" (click)="removeTab(tab)">close</mat-icon>
        </div>
      </ng-container>
    </div>
    <div class="change-btn next" (click)="scrollTab(1)" *ngIf="overflow" [ngClass]="{'hide' : scrollEnd}">
      <mat-icon>keyboard_arrow_right</mat-icon>
    </div>
    <div class="dropdown_anchor desktop" *ngIf="showTabDropdown() | async">
      <div class="tool-icon" [matMenuTriggerFor]="tabmenu">
        <span textSmall class="tabs-left" >{{persistentTabService.getTabs().length}}</span>
        <mat-icon>content_copy</mat-icon>
      </div>
      <mat-menu #tabmenu="matMenu" class="priority-menu-small tab-menu"
                xPosition="after" >
          <button mat-menu-item class="tab-menu-item mdc-theme-error" (click)="closeAllTabs()">
            <mat-icon class="mdc-theme-error">highlight_off</mat-icon>
            <div class="more-info-container mdc-theme-error">
              <div textSmall class="tab-text">Alle Tabs schließen</div>
            </div>
          </button>
        <button mat-menu-item *ngFor="let tab of persistentTabService.getTabs$() | async" class="tab-menu-item"
                (click)="navigateTab(tab)"
                [ngClass]="{'current': tab.config.idURL===(persistentTabService.getActiveId$() | async) }">
          <mat-icon>{{ tab.config.icon }}</mat-icon>
            <mat-icon class="end-icon" (click)="closeTabFromMenu($event, tab)">close</mat-icon>
            <div class="more-info-container">
              <div textSmall class="tab-text">{{ tab.config.label }}</div>
              <div textSmall class="tab-text additional">{{ tab.config.sublabel }}</div>
            </div>
          </button>
      </mat-menu>
    </div>
  </section>
  <ng-container *ngIf="deviceService.isHandset()">
    <div class="tabs-container handset">
      <div *ngIf="persistentTabService.getActiveTab$() | async; let tab" (click)="navigateTab(tab)"
           class="tab active-tab" [id]="tab.config.idURL">
        <mat-icon class="tab-icon">{{ tab.config.icon }}</mat-icon>
        <div class="more-info-container">
          <div textSmall class="tab-text">{{ tab.config.label }}</div>
          <div textSmall class="tab-text additional">{{ tab.config.sublabel }}</div>
        </div>
        <mat-icon class="close-icon" (click)="removeTab(tab)">close</mat-icon>
      </div>
    </div>

    <div class="dropdown_anchor" *ngIf="showTabDropdown() | async">
      <div class="tool-icon" [matMenuTriggerFor]="tabmenu" >
        <span textSmall class="tabs-left">{{persistentTabService.getTabs().length-(activeTabId!==null ? 1 : 0)}}</span>
        <mat-icon>content_copy</mat-icon>
      </div>

      <mat-menu #tabmenu="matMenu" class="priority-menu-small tab-menu"
                xPosition="after">
          <button mat-menu-item class="tab-menu-item mdc-theme-error" (click)="closeAllTabs()">
            <mat-icon class="mdc-theme-error">highlight_off</mat-icon>
            <div class="more-info-container mdc-theme-error">
              <div textSmall class="tab-text">Alle Tabs schließen</div>
            </div>
          </button>
        <button mat-menu-item *ngFor="let tab of getDropdownTabs() | async" class="tab-menu-item" (click)="navigateTab(tab)" >
          <mat-icon>{{ tab.config.icon }}</mat-icon>
            <mat-icon class="end-icon" (click)="closeTabFromMenu($event, tab)">close</mat-icon>
            <div class="more-info-container">
              <div textSmall class="tab-text">{{ tab.config.label }}</div>
              <div textSmall class="tab-text additional">{{ tab.config.sublabel }}</div>
            </div>
          </button>
      </mat-menu>
    </div>

  </ng-container>
</div>

